import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBrandingFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 21,
	viewBox: "0 0 22 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.0149631 9.94688C0.322383 4.17474 5.2922 -0.292457 11.0643 0.0149631C16.6867 0.314409 21.2972 4.71929 21.0476 9.95726L21.0473 9.96285C20.8637 13.4106 17.8892 16.0829 14.4419 15.8993C14.2147 15.8872 13.9886 15.861 13.7626 15.8349C13.476 15.8017 13.1895 15.7685 12.9008 15.764C12.4372 15.7568 12.2267 15.8407 12.1171 15.9392C11.8781 16.154 11.8824 16.5506 12.0343 16.719C12.7123 17.4706 12.7969 18.6427 12.3733 19.5353C11.9713 20.3826 11.0957 21.0574 9.94688 20.9962C4.17475 20.6888 -0.292457 15.719 0.0149631 9.94688ZM8.7771 5.7627C8.7771 4.65813 9.67253 3.7627 10.7771 3.7627C11.8817 3.7627 12.7771 4.65813 12.7771 5.7627C12.7771 6.86726 11.8817 7.7627 10.7771 7.7627C9.67253 7.7627 8.7771 6.86726 8.7771 5.7627ZM4.00684 9.5C4.00684 8.39543 4.90227 7.5 6.00684 7.5C7.1114 7.5 8.00684 8.39543 8.00684 9.5C8.00684 10.6046 7.1114 11.5 6.00684 11.5C4.90227 11.5 4.00684 10.6046 4.00684 9.5ZM13.2517 9.5C13.2517 8.39543 14.1471 7.5 15.2517 7.5C16.3563 7.5 17.2517 8.39543 17.2517 9.5C17.2517 10.6046 16.3563 11.5 15.2517 11.5C14.1471 11.5 13.2517 10.6046 13.2517 9.5Z",
		fill: "#111111"
	})
});
const ForwardRef = forwardRef(SvgBrandingFilled);
export default ForwardRef;
